import React from 'react'
import i18n from 'i18n-js'

import './Select.scss'

const Select = props => {
    return <div className="Select">
        <label className="label" htmlFor={props.id}>
            <span className={['select-label', props.hideLabel ? 'sr-only' : null].join(' ')}>
                {i18n.t(props.label)}
            </span>
            <div className="select-box">
                <select value={props.value}
                    id={props.id}
                    onChange={props.changed}>
                    {props.info && <option disabled>{props.info}</option>}
                    {props.options.map(el => {
                        return <option key={`${props.label}-${el.value}`} value={el.value}>{el.text || el.value}</option>
                    })}
                </select>
            </div>
            {props.icon && <img src={props.icon} alt="" />}
        </label>
    </div>
}

export default Select